<script>
    import { apnumber, capfirst, intcomma } from 'journalize';

    export let resultCount = null;
    export let searchParams = {};
    export let oldestRecentSurveyYear;

    searchParams = JSON.parse(searchParams);

    if (!searchParams.type) searchParams.type = 'school';

    let expanded = false;

    const toggleExpanded = () => {
        expanded = !expanded;
    };

    // Function to join array items with commas and an "or" for the last item
    const joinWith = (array, delimiter = ',', joinWord = 'or') => {
        if (array.length <= 1) return array.join('');
        return `${array.slice(0, -1).join(`${delimiter} `)} ${joinWord} ${array[array.length - 1]}`;
    };

    // Function to join conditions with semicolons or commas based on need
    const joinConditions = (conditionArray, delimiter = ',') => {
        return conditionArray.join(`${delimiter} `);
    };

    // Build summary based on search parameters
    let conditionDelimiter = ',';
    let conditions = [];

    if (searchParams.q) {
        conditions.push(
            `with <span class="condition-key">names containing</span> <span class="condition-value">“${searchParams.q}”</span>`,
        );
    }

    if (searchParams.year_founded_min || searchParams.year_founded_max) {
        const minYear = searchParams.year_founded_min || '1600';
        const maxYear = searchParams.year_founded_max || '1995';
        conditions.push(
            `<span class="condition-key">founded between</span> <span class="condition-value">${minYear}</span> and <span class="condition-value">${maxYear}</span>`,
        );
    }

    if (searchParams.most_recent_enrollment) {
        let rangeWord = 'range';
        if (searchParams.most_recent_enrollment.length > 1) {
            conditionDelimiter = ';';
            rangeWord = 'ranges';
        }

        const enrollmentRanges = joinWith(searchParams.most_recent_enrollment);
        conditions.push(
            `with <span class="condition-key">enrollment in ${rangeWord}</span> <span class="condition-value">${enrollmentRanges.toLowerCase()}</span>`,
        );
    }

    if (searchParams.state && searchParams.state.length) {
        if (searchParams.state.length > 1) conditionDelimiter = ';';

        const states = joinWith(searchParams.state.map((s) => `<span class="condition-value">${s}</span>`));
        conditions.push(`located in ${states}`);
    }

    if (searchParams.lea_state && searchParams.lea_state.length) {
        if (searchParams.lea_state.length > 1) conditionDelimiter = ';';

        const lea_states = joinWith(searchParams.lea_state.map((s) => `<span class="condition-value">${s}</span>`));
        conditions.push(`located in ${lea_states}`);
    }

    if (searchParams.district && searchParams.district.length) {
        if (searchParams.district.length > 1) conditionDelimiter = ';';

        const districts =
            searchParams.district.length > 1
                ? `${searchParams.district.length} districts`
                : `district ${searchParams.district[0]}`;

        conditions.push(`<span class="condition-key">within</span> <span class="condition-value">${districts}</span>`);
    }

    if (searchParams.school_type && searchParams.school_type.length) {
        if (searchParams.school_type.length > 1) conditionDelimiter = ';';

        conditions.push(
            `with <span class="condition-key">type</span> ${joinWith(searchParams.school_type.map((val) => `<span class="condition-value">${val}</span>`))}`,
        );
    }

    if (searchParams.religion && searchParams.religion.length) {
        if (searchParams.religion.length > 1) conditionDelimiter = ';';

        conditions.push(
            `with <span class="condition-key">religious affiliation</span> ${joinWith(searchParams.religion.map((val) => `<span class="condition-value">${val}</span>`))}`,
        );
    }

    if (searchParams.type === 'school' && (!searchParams.hide_inactive || searchParams.hide_inactive === '1')) {
        conditions.push(
            `with <span class="condition-key">survey responses since</span> <span class="condition-value">${oldestRecentSurveyYear}</span>`,
        );
    }

    // Format the full sentence
    const formatSummarySentence = (conditions, conditionDelimiter) => {
        const joinedConditions = joinWith(conditions, conditionDelimiter, 'and').trim();

        let sentence = `${capfirst(intcomma(apnumber(resultCount)))} results for ${searchParams.type}s${joinedConditions.length > 0 ? ' ' : ''}${joinedConditions}`;

        return sentence + '.';
    };
</script>

<div class="search-summary">
    <p>
        {@html formatSummarySentence(conditions, conditionDelimiter)}
    </p>
</div>

<style lang="scss">
    // :global(.condition-key) {
    //     font-weight: bold;
    // }

    :global(.condition-value) {
        font-weight: 500;
    }

    .search-summary {
        margin: var(--spacing0) 0;
        font-size: 1rem;
    }

    .expand-button {
        padding: 0;
        border: none;
        background: none;
        color: var(--blue-50);
        cursor: pointer;
        text-decoration: underline;
    }

    .result-count,
    .search-type {
        font-weight: bold;
    }
</style>
